/* eslint-disable react/prop-types */
import React from 'react';
import { Card as CardWrapper, CardHeader, CardBody, UncontrolledTooltip, Progress } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { formatCurrency } from '../../../helpers/format';

const generateSafeId = (text) =>
  text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9]/g, '-')
    .toLowerCase();

const BreakageCard = ({ t, data, isLoading }) => {
  const tooltipId = generateSafeId('tooltip-breakage');

  if (isLoading) {
    return <div className="skeleton card" style={{ height: '120px' }} />;
  }

  if (!data) {
    return (
      <CardWrapper className="card-summary h-100" style={{ minHeight: '120px' }}>
        <CardBody>
          <div className="text-center text-muted py-4">
            <i className="bx bx-data mb-2 fs-24 d-block"></i>
            <p className="mb-0">{t('revenue-dashboard.cards.breakage.unavailable') || 'Dados indisponíveis'}</p>
          </div>
        </CardBody>
      </CardWrapper>
    );
  }

  // TODO: P3 - Breakage data fields to be validated with product team
  const generated = data?.generated || 0;
  const redeemed = data?.redeemed || 0;
  const percentage = data?.percentage || 0;
  const total = data?.total || 0;

  // Calculate efficiency (breakage rate = generated - redeemed)
  const efficiency = generated > 0 ? ((generated - redeemed) / generated) * 100 : 0;
  const redemptionRate = generated > 0 ? (redeemed / generated) * 100 : 0;

  return (
    <CardWrapper className="card-summary h-100" style={{ minHeight: '120px' }}>
      <CardHeader>
        <div className="card-responsive d-flex align-items-center justify-content-between">
          <h6 className="m-0 text-uppercase">
            {t('revenue-dashboard.cards.breakage.title')}
            <i
              className="bx ri-question-line align-middle ms-2"
              id={tooltipId}
            ></i>
            <UncontrolledTooltip target={tooltipId}>
              {t('revenue-dashboard.cards.breakage.tooltip')}
            </UncontrolledTooltip>
          </h6>
        </div>
      </CardHeader>
      <CardBody>
        {/* Segmented bar using reactstrap Progress */}
        <div className="mb-3">
          <Progress multi style={{ height: '24px', borderRadius: '8px' }}>
            <Progress
              bar
              value={redemptionRate}
              className="bg-primary"
              style={{ borderRadius: '8px 0 0 8px' }}
            />
            <Progress
              bar
              value={efficiency}
              className="bg-info"
              style={{ borderRadius: '0 8px 8px 0' }}
            />
          </Progress>
        </div>

        {/* Labels below the bar */}
        <div className="d-flex justify-content-between mb-2">
          <small className="text-muted text-uppercase fw-semibold">
            {t('revenue-dashboard.cards.breakage.generation')}
          </small>
          <small className="text-muted text-uppercase fw-semibold">
            {t('revenue-dashboard.cards.breakage.redemption')}
          </small>
          <small className="text-muted text-uppercase fw-semibold">
            {t('revenue-dashboard.cards.breakage.efficiency')}
          </small>
        </div>

        {/* Values */}
        <div className="d-flex justify-content-between align-items-end">
          <div>
            <h4 className="fs-24 fw-semibold mb-1">
              {formatCurrency(generated)}
            </h4>
            <h6 className="fs-7 ff-secondary mb-0">
              {t('revenue-dashboard.cards.breakage.totalLabel')}: {formatCurrency(total)}
            </h6>
          </div>
          <div className="text-end">
            <h5 className="fs-18 fw-semibold mb-0">
              {percentage > 0 ? `${Math.round(percentage * 100)}%` : '0%'}
            </h5>
            <h6 className="fs-7 ff-secondary mb-0">
              {t('revenue-dashboard.cards.breakage.efficiencyMargin')}: {efficiency.toFixed(1)}%
            </h6>
          </div>
        </div>
      </CardBody>
    </CardWrapper>
  );
};

export default withTranslation()(BreakageCard);
